import { render, staticRenderFns } from "./horarioIngresoAdd.vue?vue&type=template&id=31c21e52&"
import script from "./horarioIngresoAdd.vue?vue&type=script&lang=js&"
export * from "./horarioIngresoAdd.vue?vue&type=script&lang=js&"
import style0 from "./horarioIngresoAdd.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports